import * as React from "react";
import styled, { withTheme } from "styled-components";

interface Props {
  theme?: any;
  patternType: number;
}

const PatternBackground: React.FunctionComponent<Props> = ({
  theme,
  patternType,
  children,
}) => {
  return (
    <Root
      style={{
        backgroundColor: theme.colors.background,
        color: theme.colors.foreground,
      }}
    >
      {/* <div style={{
      backgroundImage: "url(/patterns/intro.svg)",
backgroundRepeat: "no-repeat",
backgroundAttachment: "scroll",
backgroundPosition: "top right",
backgroundSize: "contain",}}> */}
      <div style={{position: "relative", zIndex: 10, height: "100%"}}>
        {children}
      </div>
      {patternType === 1 && <SVG1 />}
      {patternType === 2 && <SVG2 />}
      {patternType === 3 && <SVG3 />}
      {patternType === 4 && <SVG4 />}
      {patternType === 5 && <SVG5 />}
    </Root>
  );
};

export default withTheme(PatternBackground);

const Root = styled("div")`
  position: relative;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  overflow: hidden;
  transition: color 0.3s ease-in-out, backgroundColor 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* background: linear-gradient(
    135deg,
    rgba(43, 47, 69, 1) 0%,
    rgba(86, 82, 106, 1) 100%
  ); */
`;

interface SvgProps {}

const SVG1: React.FunctionComponent<SvgProps> = () => (
  <div
    style={{
      position: "absolute",
      right: 0,
      top: 0
    }}
  >
    <svg width="1061" height="1200">
      <g
        transform="translate(-581 -420)"
        fill="currentcolor"
        fillRule="evenodd"
      >
        <rect
          opacity=".1"
          transform="rotate(-35 1488.182 377.567)"
          x="996.682"
          y="312.067"
          width="983"
          height="131"
          rx="65.5"
        />
        <rect
          opacity=".1"
          transform="rotate(-35 1524.182 998.567)"
          x="1032.682"
          y="933.067"
          width="983"
          height="131"
          rx="65.5"
        />
        <rect
          opacity=".1"
          transform="rotate(-35 1928.182 945.567)"
          x="1436.682"
          y="880.067"
          width="983"
          height="131"
          rx="65.5"
        />
        <rect
          opacity=".1"
          transform="rotate(-35 947.182 1188.567)"
          x="755.682"
          y="1123.067"
          width="683"
          height="131"
          rx="65.5"
        />
        <rect
          opacity=".1"
          transform="rotate(-35 996.182 912.567)"
          x="504.682"
          y="847.067"
          width="983"
          height="131"
          rx="65.5"
        />
        <rect
          opacity=".1"
          transform="rotate(-35 1778.182 592.567)"
          x="1286.682"
          y="527.067"
          width="983"
          height="131"
          rx="65.5"
        />
        <rect
          opacity=".15"
          transform="rotate(-35 1827.182 335.567)"
          x="1335.682"
          y="270.067"
          width="983"
          height="131"
          rx="65.5"
        />
      </g>
    </svg>
  </div>
);

const SVG2: React.FunctionComponent<SvgProps> = () => (
  <div
    style={{
      position: "absolute",
      left: 0,
      top: 0,
      height: "100%",
      width: "100%",
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="1700" height="900">
      <g
        transform="translate(-295.939 -174)"
        fill="currentcolor"
        fillRule="evenodd"
      >
        <circle
          opacity=".1"
          transform="rotate(150 296 311.061)"
          cx="296"
          cy="311.061"
          r="216"
        />
        <circle opacity=".03" cx="1326.939" cy="1033" r="216" />
        <circle
          opacity=".1"
          transform="matrix(1 0 0 -1 0 432)"
          cx="1923.939"
          cy="216"
          r="216"
        />
      </g>
    </svg>
  </div>
);

const SVG3: React.FunctionComponent<SvgProps> = () => (
  <div
    style={{
      position: "absolute",
      left: 0,
      top: 0,
      // height: "100%",
      width: "100%",
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="1687" height="865">
      <defs>
        <linearGradient
          x1="24.678%"
          y1="8.681%"
          x2="77.338%"
          y2="87.508%"
          id="a"
        >
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="74.527%"
          y1="9.414%"
          x2="32.949%"
          y2="60.867%"
          id="b"
        >
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(405 79)">
          <circle fill="url(#a)" opacity=".05" cx="445" cy="445" r="445" />
          <circle fill="url(#b)" opacity=".1" cx="445" cy="445" r="298" />
          <circle fill="url(#b)" opacity=".1" cx="445" cy="445" r="166.304" />
        </g>
        <g opacity=".3" fill="currentcolor" fillRule="nonzero">
          <path d="M1574.464 9C1572 9 1570 6.985 1570 4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-1.999 4.5-4.465 4.5zm26.786 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.464 2.015 4.464 4.5s-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s1.999-4.5 4.465-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5S1820 2.015 1820 4.5s-1.999 4.5-4.464 4.5zM1574.464 36C1572 36 1570 33.985 1570 31.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-1.999 4.5-4.465 4.5zm26.786 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.464 2.015 4.464 4.5s-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s1.999-4.5 4.465-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zM1574.464 63C1572 63 1570 60.985 1570 58.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-1.999 4.5-4.465 4.5zm26.786 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.464 2.015 4.464 4.5s-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s1.999-4.5 4.465-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zM1574.464 90C1572 90 1570 87.985 1570 85.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-1.999 4.5-4.465 4.5zm26.786 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.464 2.015 4.464 4.5s-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s1.999-4.5 4.465-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zM1574.464 116c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-1.999 4.5-4.465 4.5zm26.786 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.464 2.015 4.464 4.5s-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s1.999-4.5 4.465-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zM1574.464 143c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-1.999 4.5-4.465 4.5zm26.786 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.464 2.015 4.464 4.5s-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s1.999-4.5 4.465-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zM1574.464 170c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-1.999 4.5-4.465 4.5zm26.786 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.464 2.015 4.464 4.5s-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s1.999-4.5 4.465-4.5c2.465 0 4.464 2.015 4.464 4.5s-1.999 4.5-4.464 4.5zm26.785 0c-2.465 0-4.464-2.015-4.464-4.5s1.999-4.5 4.464-4.5c2.466 0 4.465 2.015 4.465 4.5s-2 4.5-4.465 4.5zm26.786 0c-2.466 0-4.464-2.015-4.464-4.5s1.998-4.5 4.464-4.5 4.464 2.015 4.464 4.5-1.998 4.5-4.464 4.5zm26.786 0c-2.466 0-4.465-2.015-4.465-4.5s2-4.5 4.465-4.5 4.464 2.015 4.464 4.5-1.999 4.5-4.464 4.5z" />
        </g>
        <g opacity=".3" fill="currentcolor" fillRule="nonzero">
          <path d="M-35.571 719c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM-3 719c-2.998 0-5.429-2.462-5.429-5.5S-5.999 708-3 708c2.998 0 5.429 2.462 5.429 5.5S-.001 719-3 719zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM225 719c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zM-35.571 752c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM-3 752c-2.998 0-5.429-2.462-5.429-5.5S-5.999 741-3 741c2.998 0 5.429 2.462 5.429 5.5S-.001 752-3 752zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM225 752c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zM-35.571 785c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM-3 785c-2.998 0-5.429-2.462-5.429-5.5S-5.999 774-3 774c2.998 0 5.429 2.462 5.429 5.5S-.001 785-3 785zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM225 785c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zM-35.571 818c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM-3 818c-2.998 0-5.429-2.462-5.429-5.5S-5.999 807-3 807c2.998 0 5.429 2.462 5.429 5.5S-.001 818-3 818zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM225 818c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zM-35.571 849c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM-3 849c-2.998 0-5.429-2.462-5.429-5.5S-5.999 838-3 838c2.998 0 5.429 2.462 5.429 5.5S-.001 849-3 849zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.572 0c-2.999 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.428 2.462 5.428 5.5s-2.43 5.5-5.428 5.5zM225 849c-2.998 0-5.429-2.462-5.429-5.5s2.43-5.5 5.429-5.5c2.998 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5zm32.571 0c-2.998 0-5.428-2.462-5.428-5.5s2.43-5.5 5.428-5.5c2.999 0 5.429 2.462 5.429 5.5s-2.43 5.5-5.429 5.5z" />
        </g>
      </g>
    </svg>
  </div>
);

const SVG4: React.FunctionComponent<SvgProps> = () => (
  <div
    style={{
      position: "absolute",
      left: 0,
      top: 0,
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="1656" height="900">
      <defs>
        <linearGradient
          x1="74.527%"
          y1="16.72%"
          x2="32.949%"
          y2="58.911%"
          id="a"
        >
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="74.527%"
          y1="9.414%"
          x2="32.949%"
          y2="60.867%"
          id="b"
        >
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
        </linearGradient>
      </defs>
      <g transform="translate(-154 -46)" fill="none" fillRule="evenodd">
        <rect
          fill="url(#a)"
          opacity=".1"
          x="758"
          y="757"
          width="307"
          height="278"
          rx="53"
        />
        <rect fill="url(#a)" opacity=".15" width="307" height="278" rx="53" />
        <rect
          fill="url(#b)"
          opacity=".15"
          transform="matrix(-1 0 0 1 3203 0)"
          x="1393"
          y="184"
          width="417"
          height="417"
          rx="53"
        />
      </g>
    </svg>
  </div>
);

const SVG5: React.FunctionComponent<SvgProps> = () => (
  <div
    style={{
      position: "absolute",
      left: 0,
      top: 0,
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="1700" height="900">
      <defs>
        <linearGradient x1="23.007%" y1="17.41%" x2="100%" y2="82.047%" id="a">
          <stop stopColor="#11C6FF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="74.527%"
          y1="9.414%"
          x2="32.949%"
          y2="60.867%"
          id="b"
        >
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
        </linearGradient>
      </defs>
      <g transform="translate(-295.939 -166)" fill="none" fillRule="evenodd">
        <circle
          fill="url(#a)"
          opacity=".2"
          transform="rotate(-30 296 295.061)"
          cx="296"
          cy="295.061"
          r="216"
        />
        <circle fill="url(#b)" opacity=".1" cx="1089.939" cy="1017" r="216" />
        <circle
          fill="url(#b)"
          opacity=".1"
          transform="matrix(1 0 0 -1 0 400)"
          cx="1923.939"
          cy="200"
          r="200"
        />
        <g opacity=".3" fill="#FFF" fillRule="nonzero">
          <path d="M1860.939 787a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zM1860.939 814a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zM1860.939 841a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zM1860.939 868a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zM1860.939 894a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zM1860.939 921a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zM1860.939 948a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6zm26.785 0a3 3 0 110-6 3 3 0 010 6zm26.786 0a3 3 0 110-6 3 3 0 010 6z" />
        </g>
      </g>
    </svg>
  </div>
);
